<template>
  <section class="animation-and-qr">
    <!-- アニメーション -->
    <img class="animation" :src="animationUrl" />

    <div v-if="isValidQrString != null">
      <!-- QRコード(有効期間内) -->
      <vue-qrcode
        v-if="isValidQrString"
        class="qr"
        :value="qrString"
        tag="img"
      ></vue-qrcode>

      <!-- リロードボタン(有効期間外) -->
      <FaceQRReloadSection v-else :on-tap-reload="onTapReload" />
    </div>

    <!-- QR文字列読み込み中のレイアウト崩れ防止 -->
    <div v-else class="qr" />
  </section>
</template>

<script>
export default {
  name: "FaceAnimationAndQR",
  props: {
    animationUrl: {
      type: String,
      required: true,
    },
    isValidQrString: {
      type: Boolean,
      required: false,
      default: null,
    },
    qrString: {
      type: String,
      required: true,
    },
    onTapReload: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.animation-and-qr {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  width: 100%;
  height: 220px;
  margin: 0 0 24px;
  padding: 0;

  @media screen and (min-height: 760px) {
    margin: 0 0 60px;
  }
}
.animation-and-qr .animation {
  width: 65vw;
  height: 220px;
  object-fit: cover;
}
.animation-and-qr .qr {
  width: calc(35vw - 30px);
  height: calc(35vw - 30px);
  padding: 60px 15px;
}
</style>
